/**
 * Functions to modify links
 **/

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.download-link').forEach(link => {
    link.setAttribute('download', '')
  })

  document.querySelectorAll('.external-link').forEach(link => {
    link.setAttribute('target', '_blank')
  })

  document.querySelector('.skip-to-content-btn').addEventListener('click', function (event) {
    try {
      document.querySelector('#main').focus();
    } catch (error) {
      // Exit silently if the element is not found
    }
  });
});